export default "__VITE_ASSET__DjRrAKzf__"